const testimonialList = [
  {
    title: "¿Problemas con la gestión de los 'edificios'?",
    description: '"Si, es un sistema que mejora la gestión de los administradores de edificios y facilita la comunicación con los vecinos."',
    author: 'Edwins Vargas',
    designation: 'Inquilino residencial',
    size: 45
  },
  {
    title: '¡Adiós a los edificios pesadilla! con "Homelan"',
    description: '"Daniel ha dedicado la mayor parte de su carrera a la consultoría de gestión, pero sintió una pasión eterna por este tema, y ​​siempre sintió que tenía que hacerlo.',
    author: 'Daniel Alejandro',
    designation: 'Consultoría',
    size: 30
  }
]
export default testimonialList
